import React, { useState } from "react";
import Layout from "../components/layout";
import MainBanner from "../components/home-page/home-page-main-banner";
import CareerServices from "../components/careers/career-services";
import CareerPerks from "../components/careers/career-perks";
import CareerMission from "../components/careers/career-mission";
import SEO from '../components/seo';
import {
  mainBannerObj, CareerServicesObj, CareerPerksObj
} from '../components/careers/career-constants';

function CareerPage({ location }) {

  return (
    <Layout addBodyClass="career-page-template transparent-header" footerType="career">
      <SEO description="Boost your career growth by working on progressive technologies. Apply at hr@rapidops.com"
        meta={[{ name: "charSet", content: "utf-8" }]}
        title=" Build Your Career with Rapidops - We Are Hiring" />
      <MainBanner data={mainBannerObj} />
      <CareerServices data={CareerServicesObj} />
      <CareerPerks data={CareerPerksObj} />
      <CareerMission />
    </Layout>
  );
}


export default CareerPage;